export const shadows = {
  1: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
  2: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
  3: '0px 6px 12px 0px rgba(0, 0, 0, 0.20)',
} as const

export type Shadows = typeof shadows
